export default __webpack_public_path__ + "static/media/nabl-certificate.ea73881c.svg";